import { useStatuses } from "@/context/StatusContext";

const GROUP_LABEL = { active: "Active", paused: "Waiting", closed: "Closed" };

export default function StatusSelect({ value, onChange, disabled, testid }) {
  const { statuses, loading } = useStatuses();
  const groups = ["active", "paused", "closed"];
  const chosen = statuses.find((s) => s.key === value);
  return (
    <div className="flex items-center gap-2">
      <select
        data-testid={testid || "status-select"}
        value={value || ""}
        disabled={disabled || loading || !statuses.length}
        onChange={(e) => onChange(e.target.value)}
        className="bg-zinc-900 border border-zinc-800 rounded px-2 py-1 text-xs min-w-0"
      >
        {loading && <option value="">Loading…</option>}
        {!loading && !statuses.length && <option value="">Unavailable</option>}
        {groups.map((g) => {
          const rows = statuses.filter((s) => s.group === g);
          if (!rows.length) return null;
          return (
            <optgroup key={g} label={GROUP_LABEL[g]}>
              {rows.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
            </optgroup>
          );
        })}
      </select>
      {chosen?.pauses_sla && (
        <span className="text-[10px] font-mono text-amber-400/80 whitespace-nowrap">
          SLA clock stopped
        </span>
      )}
    </div>
  );
}
